module.exports = __webpack_public_path__ + "static/media/person.6f452221.svg";